import { LocalizedAttributesValue } from 'src/generated/operations.ts';

export const getRaw = (attr: LocalizedAttributesValue | undefined | null): string[] => {
    const raw = attr?.raw || [];
    return Array.isArray(raw) ? raw : [raw];
};
